<div>
  <h2><b>KnowYourDrive Smartphone Program</b></h2>
  <h3>For Policy {{ policy?.policyNumber | prettyPolicyNum }}</h3>
  <h3>Includes {{ policy?.riskDescriptionList | arrayToList }}</h3>
  @if (hasMultipleEligibleOperators) {
    <div>
      <p class="pad-bottom-20">
        Choose which drivers you want to enroll in KnowYourDrive. The more eligible drivers you add,
        the more money you can save!
      </p>
      <p class="pad-bottom-20">
        <span
          >Each driver you enroll needs a unique phone number associated with either an Android or
          iOS device, and they’ll have to download the KnowYourDrive app. We’ll also send any
          important KnowYourDrive communications to {{ emailId }}.
        </span>
      </p>
    </div>
  }
  @if (!hasMultipleEligibleOperators) {
    <div>
      <p class="pad-bottom-20">
        Enroll in KnowYourDrive to earn a discount on your car insurance with safe driving habits.
      </p>
      <p class="pad-bottom-20">
        <span
          >You’ll need a unique phone number associated with either an Android or iOS device, and
          you’ll have to download the KnowYourDrive app. We’ll also send any important KnowYourDrive
          communications to {{ emailId }}.
        </span>
      </p>
    </div>
  }
</div>
